import type { WorksheetSpec } from './missionLayers';

/** Open worksheet HTML in a new window and trigger the browser print dialog. */
export function printWorksheet(worksheet: WorksheetSpec): void {
  const html = worksheet.printHtml.includes('<html')
    ? worksheet.printHtml
    : `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>${escapeHtml(
        worksheet.title
      )}</title>
<style>body{font-family:Georgia,serif;max-width:720px;margin:24px auto;padding:0 20px;color:#1a1a1a}
h1{font-size:28px}</style></head><body>${worksheet.printHtml}</body></html>`;

  const win = window.open('', '_blank', 'noopener,noreferrer,width=900,height=700');
  if (!win) {
    void window.appAlert('Allow pop-ups to print the worksheet, or try again.');
    return;
  }
  win.document.open();
  win.document.write(html);
  win.document.close();
  // Give layout a tick before print
  win.focus();
  setTimeout(() => {
    try {
      win.print();
    } catch {
      /* user can print manually */
    }
  }, 250);
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
